import React from 'react'
import { Droppable } from 'react-beautiful-dnd'
import { Grid, Typography } from '@mui/material'
import DraggableCard from './DraggableCard'

const TextList = ({ id, choices, heading = null, styles, isDraggable }) => {
  return (
    <div
      key={"textList"}
    >
      {heading ? (
        <Typography variant='h4' paragraph={styles.heading}>
          {heading}
        </Typography>
      ) : null}
      <Droppable
        droppableId={id}
        direction='vertical'
      >
        {(provided, snapshot) => (
          <Grid
            container
            spacing={3}
            direction='row'
            justifyContent='flex-start'
            ref={provided.innerRef}
            sx={
              snapshot.isDraggingOver
                ? [styles.choiceSpot, styles.listOnDrag]
                : [styles.choiceSpot]
            }
          >
            {Object.entries(choices).map(([id, text], index) => {
              return (
                <DraggableCard
                  styles={styles}
                  key={'dragCard:' + id}
                  index={index}
                  item={{ id, text }}
                  isDraggable={isDraggable}
                />
              )
            })}
            {provided.placeholder}
          </Grid>
        )}
      </Droppable>
    </div >
  )
}

export default TextList
